import { render, staticRenderFns } from "./adicionarSaldoBoleto.vue?vue&type=template&id=528eaf56"
import script from "./adicionarSaldoBoleto.vue?vue&type=script&lang=ts"
export * from "./adicionarSaldoBoleto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports